var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.932 7.99961L3.99864 14.6663L2.79864 11.4663C2.39864 9.99961 3.19864 8.53295 4.53197 8.13295L22.532 2.79961C23.9986 2.39961 25.4653 3.19961 25.8653 4.53295L26.932 7.99961Z",
    fill: "#F3B763",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26562 7.06641L12.399 12.2664",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 4.53369L20.6646 9.86702",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6669H28V25.3335C28 26.0408 27.719 26.7191 27.219 27.2192C26.7189 27.7193 26.0406 28.0002 25.3333 28.0002H6.66667C5.95942 28.0002 5.28115 27.7193 4.78105 27.2192C4.28095 26.7191 4 26.0408 4 25.3335V14.6669Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducingIcon);
export default __webpack_public_path__ + "static/media/producing-icon.296f12967d1d7a8431e57c685379326c.svg";
export { ForwardRef as ReactComponent };